<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Configuración</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="save"
                :disabled="isSaving"
              >
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información de la empresa</p>
            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label">Nombre de la empresa</label>
                <argon-input type="text" v-model="form.company_name" placeholder="Ej: Mi Empresa" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Descripción</label>
                <textarea
                  class="form-control"
                  v-model="form.description"
                  rows="3"
                  placeholder="Descripción o notas"
                ></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="form.email" placeholder="contacto@empresa.com" />
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="form.phone" placeholder="+57 300 123 4567" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" placeholder="Dirección física" />
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">WordPress (API)</p>
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label">URL API de WordPress</label>
                    <argon-input type="url" v-model="form.wordpress_api_url" placeholder="https://misitio.com/wp-json" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Llave pública de WordPress</label>
                    <argon-input type="text" v-model="form.wordpress_public_key" placeholder="Llave pública (Consumer Key)" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Llave secreta de WordPress</label>
                    <argon-input :type="showWordpressSecret ? 'text' : 'password'" v-model="form.wordpress_secret_key" placeholder="Llave secreta (Consumer Secret)" />
                    
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="benefits-box">
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h5 class="form-control-label mb-0">Beneficios de tareas</h5>
                    <div class="form-check form-switch mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="benefitsOfTasksSwitch"
                        v-model="form.benefits_of_tasks"
                      />
                      <label class="form-check-label ms-2" for="benefitsOfTasksSwitch">
                        {{ form.benefits_of_tasks ? "Activo" : "Inactivo" }}
                      </label>
                    </div>
                  </div>
                  <p class="benefits-help mb-0 mt-2">
                    Al asignar un usuario a una tarea, se habilita el campo para registrar un valor de beneficio para ese usuario.
                  </p>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Logos (opcional)</p>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo claro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoLightChange"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo oscuro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoDarkChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";

export default {
  name: "Settings",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      isSaving: false,
      form: {
        company_name: "",
        description: "",
        email: "",
        phone: "",
        address: "",
        wordpress_api_url: "",
        wordpress_public_key: "",
        wordpress_secret_key: "",
        benefits_of_tasks: false,
      },
      showWordpressSecret: false,
      logoLightFile: null,
      logoDarkFile: null,
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        const data = response.data;
        this.form = {
          company_name: data.company_name || "",
          description: data.description || "",
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
          wordpress_api_url: data.wordpress_api_url || "",
          wordpress_public_key: data.wordpress_public_key || "",
          wordpress_secret_key: data.wordpress_secret_key || "",
          benefits_of_tasks: !!data.benefits_of_tasks,
        };
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
        await Swal.fire("Error", "Error al cargar la configuración", "error");
      }
    },
    onLogoLightChange(event) {
      this.logoLightFile = event.target.files?.[0] || null;
    },
    onLogoDarkChange(event) {
      this.logoDarkFile = event.target.files?.[0] || null;
    },
    async save() {
      this.isSaving = true;
      try {
        const formData = new FormData();
        formData.append("company_name", this.form.company_name);
        formData.append("description", this.form.description);
        formData.append("email", this.form.email);
        formData.append("phone", this.form.phone);
        formData.append("address", this.form.address);
        formData.append("wordpress_api_url", this.form.wordpress_api_url || "");
        formData.append("wordpress_public_key", this.form.wordpress_public_key || "");
        formData.append("wordpress_secret_key", this.form.wordpress_secret_key || "");
        formData.append("benefits_of_tasks", this.form.benefits_of_tasks ? "1" : "0");
        if (this.logoLightFile) {
          formData.append("logo_path", this.logoLightFile);
        }
        if (this.logoDarkFile) {
          formData.append("logo_path_dark", this.logoDarkFile);
        }

        await this.$store.dispatch("settings/save", formData);
        await Swal.fire("Éxito", "Configuración guardada correctamente", "success");
        this.logoLightFile = null;
        this.logoDarkFile = null;
        document.querySelectorAll('input[type="file"]').forEach((el) => (el.value = ""));
      } catch (error) {
        console.error("Error al guardar:", error);
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "Error al guardar la configuración",
          "error"
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.benefits-box {
  border: 1px solid #e9ecef;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #f8f9fa;
}

.benefits-help {
  color: #67748e;
  font-size: 0.95rem;
  line-height: 1.55;
}
</style>
